import { PropTypes } from "prop-types"
import classNames from "classnames"

import SelectField from "./SelectField"
import errorPropTypes from "./errorPropTypes"

export const TimeField = ({ className, value, ...rest }) => {
  return (
    <SelectField
      className={classNames("oj-time-field", className)}
      {...rest}
      selectedValue={value}
    />
  )
}

TimeField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  onFocus: PropTypes.func
}

export default TimeField
